<template>
  <div>
    <div class="m-b-5 ovf-hd">
      <!-- <div class="fl m-r-30" v-show="addShow">
        <router-link class="btn-link-large add-btn" to="add">
          <i class="el-icon-plus"></i>&nbsp;&nbsp;添加用户
        </router-link>
      </div> -->
      <div class="fl w-400">
        <el-input placeholder="请输入凭证编号/关联人/发票代码/发票号码" clearable v-model="keywords">
          <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
        </el-input>
      </div>
    </div>
    <el-table
    :data="tableData"
    :height="setHeight.page_height"
    style="width: 100%"
    border
    @selection-change="selectItem">
      <el-table-column
      type="selection"
      width="50">
      </el-table-column>
      <el-table-column
      prop="document_number"
      label="凭证编号"
      width="180"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      label="档案管理企业"
      width="120"
      :show-overflow-tooltip="true">
      <template scope="scope">
          <div>
            <span v-if = "scope.row.company_name==null">个人</span>
            <span v-else>{{ scope.row.company_name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
      prop="user_name"
      label="凭证关联人"
      width="120"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="code"
      label="发票代码"
      width="180"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="number"
      label="发票号码"
      width="150"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="day"
      label="开票日期"
      width="120"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="no_tax_money"
      label="不含税金额"
      width="200"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="tax_money"
      label="税额"
      width="200"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="money"
      label="价税合计金额"
      width="200"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="unit"
      label="销售方"
      width="200"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="project"
      label="项目名称"
      width="200"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="create_time"
      width="180"
      label="导入时间">
      </el-table-column>
      <el-table-column
      label="状态"
      width="100">
        <template scope="scope">
          <div>
            <span v-if = "scope.row.status ==1" style="color:#0c0">正常</span>
            <span v-else-if = "scope.row.status ==0"  style="color:#bb0">{{ scope.row.status | status }}</span>
            <span v-else-if = "scope.row.status ==-1" style="color:#d00">{{ scope.row.status | status }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
      label="验真状态"
      :show-overflow-tooltip="true"
      width="100">
        <template scope="scope">
          <div>
            <span v-if = "scope.row.is_really ==1" class="success_status">验真成功</span>
            <span v-else-if = "scope.row.is_really ==0">未验真</span>
            <span v-else-if = "scope.row.is_really ==-1" class="error_status">验真失败</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
      label="报销状态"
      :show-overflow-tooltip="true"
      width="150">
        <template scope="scope">
          <div>
            <span v-if = "scope.row.bill_status >=1 && scope.row.bill_status <=6 && scope.row.bill_status !=4" class="goon_status">报销中</span>
            <span v-else-if = "scope.row.bill_status ==4" class="error_status">驳回</span>
            <span v-else-if = "scope.row.bill_status ==0" class="goon_status">待提交</span>
            <span v-else-if = "scope.row.bill_status ==7" class="success_status">已报销</span>
            <span v-else-if = "scope.row.bill_status==-1">未报销</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
      label="文件预览"
      fixed="right"
      width="100">
        <template scope="scope">
          <div>
            <el-button v-if="scope.row.img_type == 2" type="success" size="small" v-on:click="ofd_detail=[];ofd_detail=scope.row;look_ofd_file=true">预览文件</el-button>
            <el-button v-if="scope.row.img_type != 2" type="success" size="small" v-on:click="img_detail=[];img_detail=scope.row;look_img_file=true">预览文件</el-button>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column
      label="操作"
      width="210"
      fixed="right">
        <template scope="scope">
          <div>
            <span>
              <el-button size="small" type="primary" @click="$router.push({ name: 'invoiceEdit', params: { id: scope.row.id }})">编辑</el-button>
              <el-button size="small" type="primary" @click="details(scope.row)">详情</el-button>
              <el-button size="small" type="danger" @click="confirmDelete(scope.row.id)">删除</el-button>
            </span>
            <span>
            </span>
          </div>
        </template>
      </el-table-column> -->
    </el-table>
    <el-drawer
      title="详情"
      :visible.sync="dialogVisible"
      :direction="direction">
      <div>
        档案管理企业：<span><b v-text="detail.company_name?detail.company_name:'无'"></b></span>
      </div>
      <div>
        凭证关联人：<span><b>{{detail.user_name}}</b></span>
      </div>
      <div>
        发票代码：<span><b>{{detail.code}}</b></span>
      </div>
      <div>
        发票号码：<span><b>{{detail.number}}</b></span>
      </div>
      <div>
        开票日期：<span><b>{{detail.day}}</b></span>
      </div>
      <div>
        往来单位：<span><b>{{detail.unit}}</b></span>
      </div>
      <div>
        不含税金额：<span><b>{{detail.no_tax_money}}</b> 元</span>
      </div>
      <div>
        税额：<span><b>{{detail.tax_money}}</b> 元</span>
      </div>
      <div>
        价税合计金额：<span><b>{{detail.money}}</b> 元</span>
      </div>
      <div>
        凭证编号：<span><b>{{detail.document_number}}</b></span>
      </div>
      <div>
        导入时间：<span><b>{{detail.create_time}}</b></span>
      </div>
      <div>
        发票：
          <el-popover
            v-if="detail.img_type == 1"
            placement="left-end"
            width="400"
            trigger="click">
            <object :data="detail.url" type="application/pdf" width="100%"></object>
            <object :data="detail.url" type="application/pdf" width="100" height="100" style="cursor: pointer" slot="reference"></object>
          </el-popover>
          
          <el-popover
            v-if="detail.img_type == 3"
            placement="left-end"
            width="400"
            trigger="click">
            <img :src="detail.url" width="100%">
            <img :src="detail.url" width="100" height="100" style="cursor: pointer" class="m-r-10" slot="reference">
          </el-popover>
          <span v-if="detail.img_type == 2">ofd文件，暂不支持查看</span>
      </div>
      <div>
        附件：
          <el-popover
            v-for="item in detail.enclosure"
            placement="right-end"
            width="400"
            trigger="click">
            <img :src="item" width="100%">
            <img :src="item" width="100" height="100" style="cursor: pointer" class="m-r-10" slot="reference">
          </el-popover>
      </div>
    </el-drawer>
    <div class="pos-rel p-t-20">
      <!-- <btnGroup :selectedData="multipleSelection" :type="'invoice'"></btnGroup> -->
      <div class="block pages">
        <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :page-size="limit"
        :current-page="currentPage"
        :total="dataCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="" :visible.sync="look_ofd_file" append-to-body :close-on-click-modal="true" :show-close="false" custom-class="w-800">
      <ofdGroup :ofd_detail="ofd_detail" v-on:closeMain="look_ofd_file=false;"></ofdGroup>
    </el-dialog>
    <el-dialog title="" :visible.sync="look_img_file" append-to-body :close-on-click-modal="true" :show-close="false" custom-class="w-800">
      <imgGroup :img_detail="img_detail" v-on:closeMain="look_img_file=false;"></imgGroup>
    </el-dialog>
  </div>
</template>
<style scoped>
.rtl{
    width:380px !important;
    color:#555 !important;
  }
  .rtl .el-drawer__header span{
    font-size:40px !important;
    color:#111 !important;
  }
  .rtl div{
    margin-left:35px;
    color:#555;
  }
  .rtl div span{
    color:#111;
  }
</style>
<script>
  import btnGroup from '../../../Common/btn-group.vue'
  import ofdGroup from '../../../Common/ofd.vue'
  import imgGroup from '../../../Common/image.vue'
  import http from '../../../../assets/js/http'

  export default {
    data() {
      return {
        showbtn: false,
        tableData: [],
        dataCount: null,
        currentPage: null,
        look_ofd_file: false,
        look_img_file: false,
        ofd_detail: [],
        img_detail: [],
        keywords: '',
        multipleSelection: [],
        limit: 15,
        dialogVisible: false,
        direction: 'rtl',
        detail: []
      }
    },
    methods: {
      details(obj) {
        this.detail = obj
        this.dialogVisible = true
      },
      search() {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: 1 }})
      },
      selectItem(val) {
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: page }})
      },
      confirmDelete(id) {
        this.$confirm('确认删除该发票?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _g.openGlobalLoading()
          this.apiDelete('admin/invoice/', id).then((res) => {
            _g.closeGlobalLoading()
            this.handelResponse(res, (data) => {
              _g.toastMsg('success', '删除成功')
              setTimeout(() => {
                _g.shallowRefresh(this.$route.name)
              }, 1500)
            })
          })
        }).catch(() => {
          // catch error
        })
      },
      getAllUsers() {
        this.loading = true
        const data = {
          params: {
            keywords: this.keywords,
            page: this.currentPage,
            limit: this.limit
          }
        }
        this.apiGet('admin/invoice', data).then((res) => {
          // console.log('res = ', _g.j2s(res))
          this.handelResponse(res, (data) => {
            this.tableData = data.list
            this.dataCount = data.dataCount
          })
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      getKeywords() {
        let data = this.$route.query
        if (data) {
          if (data.keywords) {
            this.keywords = data.keywords
          } else {
            this.keywords = ''
          }
        }
      },
      init() {
        this.getKeywords()
        this.getCurrentPage()
        this.getAllUsers()
      }
    },
    created() {
      this.init()
    },
    computed: {
      addShow() {
        return _g.getHasRule('user-save')
      },
      editShow() {
        return _g.getHasRule('user-update')
      },
      deleteShow() {
        return _g.getHasRule('user-delete')
      }
    },
    watch: {
      '$route' (to, from) {
        this.init()
      }
    },
    components: {
      btnGroup,
      ofdGroup,
      imgGroup
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// list.vue?535205aa